import { useCallback, useEffect, useMemo, useReducer, useState } from 'react';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { fetchCustomers, selectAllCustomers } from '../../../slices/customers/customersSlice';
import { selectAllCompanies } from '../../../slices/companies/companiesSlice';

function reducer(state: any, action: any) {
  switch (action.type) {
    case 'setSearchString': {
      return {
        ...state,
        searchString: action.searchString,
      };
    }
  }
}

export const useCustomerProfiles = () => {
  const dispatchCustom = useAppDispatch();
  const company = useAppSelector(selectAllCompanies)[0];
  const customers = useAppSelector(selectAllCustomers);
  const customersCount = useAppSelector((state) => state.customers.customersCount);
  const customersLoading = useAppSelector((state) => state.customers.status);
  const [cardView, setCardView] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchStringInputValue, setSearchStringInputValue] = useState('');
  const [searchCleared, setSearchCleared] = useState(false);
  const [state, dispatch] = useReducer(reducer, { searchString: '' });

  const searchParams: {
    company_id: number;
    sort?: string;
    order?: string;
    name?: string;
    page?: number;
  } = useMemo(
    () => ({
      company_id: company?.id ?? 0,
      ...(state.searchString ? { name: state.searchString } : {}),
      sort: 'name',
      order: 'ASC',
    }),
    [company?.id, state.searchString]
  );

  const getNextPage = () => {
    dispatchCustom(
      fetchCustomers({
        ...searchParams,
        page: currentPage + 1,
      })
    );
    setCurrentPage(currentPage + 1);
  };

  const getRequestedPage = (page: number) => {
    dispatchCustom(
      fetchCustomers({
        ...searchParams,
        page,
      })
    );
    setCurrentPage(page);
  };

  const getPrevPage = () => {
    dispatchCustom(
      fetchCustomers({
        ...searchParams,
        page: currentPage - 1,
      })
    );
    setCurrentPage(currentPage - 1);
  };

  const setSearchStringValue = useCallback(() => {
    if (customersLoading !== 'loading') {
      dispatch({ type: 'setSearchString', searchString: searchStringInputValue });
    }
  }, [customersLoading, searchStringInputValue]);

  const resetSearchFilter = useCallback(() => {
    dispatch({ type: 'setSearchString', searchString: '' });
    setSearchStringInputValue('');
    setSearchCleared(true);
    //dispatchCustom(fetchCustomers({ ...searchParams, page: currentPage }));
  }, [setSearchCleared]);

  const fetchCustomersRequest = useCallback(() => {
    //if (company) {
    dispatchCustom(fetchCustomers({ ...searchParams, page: currentPage }));
    //}
  }, [currentPage, dispatchCustom, searchParams]);

  useEffect(() => {
    fetchCustomersRequest();
  }, [fetchCustomersRequest]);

  useEffect(() => {
    setSearchStringValue();
  }, [setSearchStringValue]);

  return {
    cardView,
    setCardView,
    customers,
    customersLoading,
    getNextPage,
    getPrevPage,
    getRequestedPage,
    currentPage,
    setCurrentPage,
    customersCount,
    resetSearchFilter,
    searchCleared,
    setSearchCleared,
    searchStringInputValue,
    setSearchStringInputValue,
  };
};
